<template>
  <Applicationlayout></Applicationlayout>
</template>

<script>
import Applicationlayout from '@/components/dashboard/applications/Applicationlayout'
export default {
  components: {
    Applicationlayout
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Cancelledapplications.vue